import { render, staticRenderFns } from "./DeleteCommentModal.vue?vue&type=template&id=73f8e182&"
import script from "./DeleteCommentModal.vue?vue&type=script&lang=js&"
export * from "./DeleteCommentModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports